// Detailed properties for individual resume items - Phillip Justus

const PHIL_CONTACT = {
  telephone: '(215) 868-8981',
  email: 'philjustus@gmail.com',
  office: 'Langhorne, PA',
};

export const detailedProperties = {
  // ===== PROFILE - 8 Role Titles =====
  // The four roles below ('cyber-eng', 'grc', 'iam', 'issm', 'isso') use kind='role'
  // which renders extended tabs: Responsibilities / Tools / Frameworks / Metrics.

  'role-cyber-eng': {
    kind: 'role',
    general: {
      firstName: 'Cybersecurity',
      lastName: 'Engineer',
      displayName: 'Cybersecurity Engineer',
      description: 'Endpoint, SIEM, threat detection, hardening, automation',
      ...PHIL_CONTACT,
      webPage: '',
    },
    summary: 'Cybersecurity Engineer with expertise in endpoint security, threat detection, SIEM operations, system hardening, vulnerability management, security automation, and enterprise defense across Windows, Linux, cloud, and hybrid environments.',
    competencies: [
      'Endpoint Security','Threat Detection','Threat Hunting','SIEM Operations','Detection Engineering',
      'Incident Response','Vulnerability Management','Security Automation','System Hardening','Identity Security',
      'Cloud Security','Zero Trust','Log Analysis','Attack Surface Reduction','Security Monitoring',
      'Infrastructure Security','Risk Reduction','Security Analytics',
    ],
    tools: [
      'CrowdStrike','FortiEDR','Splunk','Arctic Wolf','Microsoft Defender for Endpoint',
      'Defender for Identity','Azure','Entra ID','Rapid7','Nessus',
      'PowerShell','Python','SCCM','Group Policy','Linux','Windows Server',
    ],
    technicalSkills: [
      'Endpoint telemetry analysis','IOC investigation','Authentication event analysis','SIEM query development',
      'False positive reduction','Windows hardening','Linux hardening','Patch management','Detection tuning',
      'Threat correlation','PowerShell automation','Security reporting automation','Risk prioritization',
      'MITRE ATT&CK mapping','Alert triage','Security baselines','Threat intelligence analysis',
      'Incident escalation','Security control implementation',
    ],
    frameworks: ['NIST 800-53','NIST CSF','CIS Controls','DISA STIG','Zero Trust','HITRUST'],
    responsibilities: [
      'Monitor and investigate security alerts','Analyze endpoint behavioral activity','Tune SIEM detections',
      'Reduce false positives','Perform system hardening','Remediate vulnerabilities','Deploy MFA protections',
      'Review authentication anomalies','Develop PowerShell security automation','Implement security baselines',
      'Support incident response','Improve security visibility','Validate secure configurations',
    ],
    metrics: [
      'Reduced vulnerability backlog by 30%',
      'Reduced response times by 20%',
      'Improved detection accuracy through SIEM optimization',
      'Supported enterprise security operations across 50+ environments',
    ],
    memberOf: [
      'Cybersecurity Engineering','Security Admins','Cybersecurity Tools','Splunk Enterprise',
      'CrowdStrike Falcon','Microsoft Defender XDR','MITRE ATT&CK','PowerShell Scripting',
    ],
  },

  'role-grc': {
    kind: 'role',
    general: {
      firstName: 'GRC',
      lastName: 'Analyst',
      displayName: 'GRC Analyst',
      description: 'Governance, Risk, and Compliance practitioner',
      ...PHIL_CONTACT,
      webPage: '',
    },
    summary: 'Governance, Risk, and Compliance analyst focused on security frameworks, risk analysis, control validation, audit readiness, policy development, compliance assessments, and technical governance across enterprise environments.',
    competencies: [
      'Risk Management','Compliance Analysis','Governance','Control Validation','Audit Readiness',
      'Policy Development','Security Documentation','Risk Assessments','Gap Analysis','Continuous Monitoring',
      'Security Standards','Control Mapping','Security Governance','Compliance Reporting','Technical Writing',
      'POA&M Management','Security Assessments',
    ],
    tools: ['Archer','ServiceNow','SCAP','ACAS','SCC','Nessus','Rapid7','Splunk','PowerShell'],
    technicalSkills: [
      'Control assessment','Policy writing','Risk analysis','Audit evidence collection','Security documentation',
      'Compliance tracking','POA&M management','Vulnerability validation','STIG assessment',
      'Control implementation review','Risk prioritization','Security baseline validation',
      'Technical procedure development','Continuous monitoring support','Compliance reporting',
    ],
    frameworks: ['NIST 800-53','NIST CSF','DISA STIG','HITRUST','CIS Controls','RMF','Zero Trust'],
    responsibilities: [
      'Develop security policies','Review compliance posture','Validate technical controls','Support audit readiness',
      'Track remediation efforts','Conduct risk assessments','Perform gap analysis','Manage POA&M documentation',
      'Coordinate compliance reviews','Review vulnerability findings','Validate STIG compliance',
      'Support governance initiatives',
    ],
    metrics: [
      'Improved compliance alignment across enterprise systems',
      'Reduced recurring security findings',
      'Improved remediation tracking visibility',
    ],
    memberOf: [
      'Regulatory Compliance','Risk Assessment & Mitigation','NIST SP 800-53 / RMF',
      'Security Artifacts (SCTM/POA&M/SSP/RAR/IA SOP)','ATO & Continuous Monitoring','Vulnerability Remediation / POA&M',
    ],
  },

  'role-iam': {
    kind: 'role',
    general: {
      firstName: 'IAM',
      lastName: 'Analyst',
      displayName: 'IAM Analyst',
      description: 'Identity and Access Management specialist',
      ...PHIL_CONTACT,
      webPage: '',
    },
    summary: 'Identity and Access Management professional specializing in authentication security, access governance, MFA, RBAC, privileged access management, identity lifecycle management, and hybrid identity protection.',
    competencies: [
      'Identity Governance','Access Management','Authentication Security','Conditional Access','MFA','SSO','RBAC',
      'Privileged Access Management','Identity Protection','Access Reviews','Least Privilege','Identity Monitoring',
      'Identity Lifecycle Management','Hybrid Identity','Federation','Role Management',
      'Privileged Identity Management','Directory Security',
    ],
    tools: ['Entra ID','Azure AD','Active Directory','Okta','Microsoft 365 Security','Defender for Identity','PowerShell','Group Policy'],
    technicalSkills: [
      'Conditional Access policy implementation','MFA deployment','Authentication monitoring',
      'Risky sign-in analysis','RBAC administration','Privileged access review','User provisioning',
      'Account lifecycle management','Identity auditing','Access certification','Identity telemetry analysis',
      'Hybrid identity administration','Federation concepts','SSO configuration','Least privilege enforcement',
      'Service account governance',
    ],
    frameworks: ['NIST 800-53','Zero Trust','HITRUST','CIS Controls'],
    responsibilities: [
      'Manage authentication security','Review privileged accounts','Analyze risky sign-ins',
      'Investigate account lockouts','Implement MFA','Review Conditional Access policies',
      'Audit access permissions','Monitor identity anomalies','Perform identity governance reviews',
      'Enforce least privilege','Support identity lifecycle operations','Review stale accounts',
    ],
    metrics: [
      'Reduced unauthorized access risk through MFA improvements',
      'Improved visibility into authentication activity',
      'Strengthened enterprise identity governance posture',
    ],
    memberOf: [
      'Identity and Access Management (IAM)','Identity & Access Management','Active Directory',
      'Microsoft Azure / Entra ID','Zero Trust Architecture','Group Policy (GPO)',
    ],
  },

  'role-issm': {
    kind: 'role',
    general: {
      firstName: 'ISSM',
      lastName: 'ISSO',
      displayName: 'ISSM / ISSO',
      description: 'Information System Security Manager / Officer',
      ...PHIL_CONTACT,
      webPage: '',
    },
    summary: 'Cybersecurity professional executing the full ISSM and ISSO scope: owning end-to-end security posture for authorized information systems while also performing the day-to-day operator activities that keep them compliant. Manages POA&M lifecycle, leads vulnerability management and audit-readiness, validates technical controls, and coordinates with system owners and authorizing officials. Equally comfortable producing oversight-level documentation and rolling up sleeves to remediate findings, tune detections, and harden systems.',
    competencies: [
      'RMF','A&A (Assessment & Authorization)','Continuous Monitoring','Security Authorization',
      'Vulnerability Management','STIG Compliance','Security Control Validation','POA&M Management',
      'System Hardening','Audit Coordination','Security Operations','Compliance Oversight',
      'Security Documentation','Risk Reduction','Configuration Management','Incident Coordination',
      'Federal Security Standards',
    ],
    tools: ['ACAS','SCAP','SCC','Splunk','CrowdStrike','FortiEDR','PowerShell','Archer','ServiceNow','Windows Server','Linux'],
    technicalSkills: [
      'RMF lifecycle support','Security control validation','Vulnerability remediation','STIG assessment',
      'POA&M tracking','Continuous monitoring','Security documentation','Audit support','System hardening',
      'Compliance validation','Risk assessment','Baseline enforcement','Security review coordination',
      'Incident review','Control implementation support',
    ],
    frameworks: ['NIST 800-53','RMF','DISA STIG','NIST CSF','Zero Trust','FedRAMP'],
    responsibilities: [
      'Support system authorization activities','Review vulnerability findings','Coordinate remediation tracking',
      'Validate security controls','Review STIG compliance','Manage POA&M items','Conduct security assessments',
      'Support continuous monitoring','Review secure configurations','Coordinate audit preparation',
      'Implement federal security requirements','Support security operations',
    ],
    metrics: [
      'Achieved 50+ Authorities to Operate (ATOs) across DoD initiatives',
      'Reduced vulnerability backlog by 30%',
      'Supported enterprise security operations across 50+ environments',
      'Improved operational security posture through control implementation',
    ],
    memberOf: [
      'Regulatory Compliance','NIST SP 800-53 / RMF','NISPOM / DAAPM / JSIG',
      'ATO & Continuous Monitoring','Security Artifacts (SCTM/POA&M/SSP/RAR/IA SOP)','Security Admins',
    ],
  },

  'role-sysadmin': {
    kind: 'job',
    general: {
      firstName: 'IT System',
      lastName: 'Administrator',
      displayName: 'IT System Administrator',
      description: 'Enterprise systems administration and operations',
      ...PHIL_CONTACT,
      webPage: '',
    },
    summary: 'Installs, configures, and maintains servers and other computer systems; plans for responding to outages and interruptions. Administers server-based networked systems, distributed applications, network storage, messaging, and application monitoring required to provision, sustain, operate, and integrate cyber networked systems. Skilled with Windows Server, Active Directory, GPO, Linux, virtualization (vSphere / Hyper-V), and PowerShell automation.',
    memberOf: ['Enterprise Infrastructure & Network Mgmt', 'Active Directory', 'Group Policy (GPO)', 'Windows Server (2008-2025)', 'Linux (RHEL / Ubuntu)', 'PowerShell Scripting'],
  },

  // ===== CERTIFICATIONS =====
  'cert-cissp': {
    kind: 'cert',
    general: {
      displayName: 'CISSP',
      issuer: 'ISC2',
      issued: 'Certified Since 2023',
      expires: 'Mar 1, 2026 - Feb 28, 2029 (current cycle)',
      credentialId: '914748',
      verify: 'https://www.isc2.org/register-for-exam/verify-a-certification',
      description: 'Certified Information Systems Security Professional',
    },
    summary: 'ISC2 gold-standard credential covering 8 CBK domains: Security & Risk Management, Asset Security, Security Architecture & Engineering, Communication & Network Security, Identity & Access Management, Security Assessment & Testing, Security Operations, and Software Development Security.',
  },
  'cert-ccsp': {
    kind: 'cert',
    general: {
      displayName: 'CCSP',
      issuer: 'ISC2',
      issued: 'Certified Since 2024',
      expires: 'Nov 1, 2024 - Oct 31, 2027',
      credentialId: '914748',
      verify: 'https://www.isc2.org/register-for-exam/verify-a-certification',
      description: 'Certified Cloud Security Professional',
    },
    summary: 'ISC2 cloud-security credential covering Cloud Concepts & Architecture, Cloud Data Security, Cloud Platform & Infrastructure Security, Cloud Application Security, Cloud Security Operations, and Legal / Risk / Compliance.',
  },
  'cert-secplus': {
    kind: 'cert',
    general: {
      displayName: 'CompTIA Security+',
      issuer: 'CompTIA',
      issued: 'Active',
      expires: 'Renewed via Continuing Education Units (CEUs)',
      credentialId: 'COMP001022XXXXXX',
      verify: 'https://www.certmetrics.com/comptia/public/verification.aspx',
      description: 'Foundational cybersecurity certification - DoD 8570 IAT II / IAM I baseline',
    },
    summary: 'Vendor-neutral cybersecurity certification recognized as a baseline credential under DoD Directive 8570 / 8140 for IAT Level II and IAM Level I roles. Validates working knowledge of core security concepts: threats, vulnerabilities, and mitigations; security architecture; security operations; and security program management.',
  },
  'cert-als': {
    kind: 'cert',
    general: {
      displayName: 'Airmen Leadership School',
      issuer: 'United States Air Force',
      issued: '',
      expires: 'Does not expire',
      credentialId: '',
      verify: '',
      description: 'USAF professional military education - prerequisite for Staff Sergeant',
    },
    summary: 'Professional military education completed as a prerequisite for promotion to Staff Sergeant (E-5). Covers leadership principles, effective communication, military professionalism, and supervisory fundamentals.',
  },

  // ===== Computers (5 lab/work systems) =====
  'comp-1': { kind: 'project', os: { os: 'Windows 11 Enterprise', version: '23H2', servicePack: '' }, general: { name: 'WS-PJUSTUS-01', dnsName: 'ws-pjustus-01.philjustus.local', role: 'Primary Workstation' }, summary: 'Daily-driver workstation with Splunk Forwarder, CrowdStrike Falcon, BitLocker, and STIG-aligned baseline. Member of Workstation Admins for local elevation.', tech: ['Windows 11', 'BitLocker', 'CrowdStrike Falcon', 'Splunk UF'], repo: '' },
  'comp-2': { kind: 'project', os: { os: 'Windows Server 2022', version: '21H2', servicePack: '' }, general: { name: 'LAB-SPLUNK', dnsName: 'lab-splunk.philjustus.local', role: 'SIEM Lab Server' }, summary: 'Splunk Enterprise lab instance for SPL development, dashboard prototyping, and detection-rule testing against simulated attack data.', tech: ['Splunk Enterprise', 'Sysmon', 'Atomic Red Team', 'Windows Event Forwarding'], repo: '' },
  'comp-3': { kind: 'project', os: { os: 'Red Hat Enterprise Linux 9', version: '9.3', servicePack: '' }, general: { name: 'LAB-NESSUS', dnsName: 'lab-nessus.philjustus.local', role: 'Vulnerability Scanner' }, summary: 'Tenable Nessus / ACAS scanner used for authenticated scans, STIG/SCAP benchmark evaluation, and POA&M-driving vulnerability reports.', tech: ['Tenable Nessus', 'ACAS', 'SCAP Compliance Checker', 'STIG Viewer'], repo: '' },
  'comp-4': { kind: 'project', os: { os: 'Windows 10 IoT Enterprise', version: 'LTSC', servicePack: '' }, general: { name: 'LAB-FORENSICS', dnsName: 'lab-forensics.philjustus.local', role: 'Forensics Workstation' }, summary: 'Air-gapped forensic analysis station for memory captures, disk imaging, and malware triage. Used to reconstruct incident timelines.', tech: ['FTK Imager', 'Volatility', 'Autopsy', 'YARA'], repo: '' },
  'comp-5': { kind: 'project', os: { os: 'Windows Server 2022', version: '21H2', servicePack: '' }, general: { name: 'LAB-PWSH', dnsName: 'lab-pwsh.philjustus.local', role: 'Automation / Build Host' }, summary: 'PowerShell automation host. Runs scheduled audit scripts, AD hygiene checks, and IaC pipelines for repeatable hardening.', tech: ['PowerShell 7', 'Ansible', 'Terraform', 'Git'], repo: '' },

  // ===== EDUCATION (now groups - keep detailed view) =====
  'edu-1': {
    kind: 'group',
    general: {
      displayName: 'Associates - Computer Science (in progress)',
      institution: 'Some College',
      dates: 'Ongoing',
      gpa: '',
      honors: '',
      description: 'Associates Degree in Computer Science (Some College)',
    },
    summary: 'Coursework in computer science fundamentals - programming, data structures, systems, and foundational mathematics.',
  },
  'edu-2': {
    kind: 'group',
    general: {
      displayName: 'Cyber Operations Tech School',
      institution: 'Keesler AFB, Biloxi, MS',
      dates: '',
      gpa: '',
      honors: '',
      description: 'USAF Cyber Systems Operations initial skills training',
    },
    summary: 'Initial skills training for USAF Cyber Systems Operations (3D0X2) at Keesler AFB. Hands-on curriculum covering server administration, network operations, information assurance, and mission systems.',
  },

  // ===== Custom Groups =====
  'g-secadmins': {
    kind: 'security_group',
    general: { displayName: 'Security Admins', scope: 'Global', category: 'Security', description: 'Cybersecurity administration group' },
    summary: 'Members of this group hold cybersecurity-administration responsibilities across the philjustus.local domain - SIEM configuration, EDR policy, vulnerability scanning, and incident response leadership.',
    members: ['Phillip Justus'],
  },
  'g-wsadmins': {
    kind: 'security_group',
    general: { displayName: 'Workstation Admins', scope: 'Global', category: 'Security', description: 'Local-admin rights on all workstations and lab hosts' },
    summary: 'Membership in this group is what controls local-administrator rights on the workstations and lab hosts (WS-PJUSTUS-01, LAB-SPLUNK, LAB-NESSUS, LAB-FORENSICS, LAB-PWSH). Domain Admins is intentionally NOT used for routine workstation administration in line with tiered-admin best practices.',
    members: ['Phillip Justus'],
  },
  'g-da': {
    kind: 'security_group',
    general: { displayName: 'Domain Admins', scope: 'Global', category: 'Security', description: 'Designated administrators of the domain' },
    summary: 'Domain Admins is the only group authorized to manage Domain Controllers in the philjustus.local domain. Membership is tightly controlled and used exclusively for domain-tier administrative tasks (Tier 0).',
    members: ['Administrator'],
  },
};
